import { NumInput, SumToOneBar } from './primitives.jsx';

const CHANNEL_KEYS = [
  'organic',
  'partnerships',
  'performance',
  'cryptoNative',
  'content',
  'referral',
];
const CHANNEL_LABEL = {
  organic: 'Organic',
  partnerships: 'Partnerships',
  performance: 'Performance',
  cryptoNative: 'Crypto-native',
  content: 'Content',
  referral: 'Referral',
};

export default function ChannelsSection({ channelMix, set }) {
  const weights = Object.fromEntries(CHANNEL_KEYS.map((k) => [k, channelMix[k]?.weight ?? 0]));
  return (
    <div className="rounded-box border border-carbon-100 bg-white overflow-hidden">
      <div className="px-4 py-3 border-b border-carbon-100 flex items-baseline justify-between gap-3 flex-wrap">
        <div>
          <p className="label text-carbon-800">Channel mix · CAC modeling</p>
          <p className="caption text-carbon-400 mt-1">
            Weights sum to 1.0; CPA is per-channel acquisition cost
          </p>
        </div>
        <SumToOneBar values={weights} label="Weights" />
      </div>
      <div className="overflow-x-auto nice-scroll">
        <table className="w-full text-left">
          <thead className="bg-carbon-50">
            <tr className="caption text-carbon-500">
              <th className="px-3 py-2">Channel</th>
              <th className="px-3 py-2 text-right">Weight</th>
              <th className="px-3 py-2 text-right">CPA ($)</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-carbon-100">
            {CHANNEL_KEYS.map((ck) => {
              const c = channelMix[ck];
              return (
                <tr key={ck}>
                  <td className="px-3 py-2 label text-carbon-800">{CHANNEL_LABEL[ck]}</td>
                  <td className="px-3 py-2 text-right">
                    <NumInput
                      value={c.weight}
                      pct
                      step={0.01}
                      onChange={(v) => set(`channelMix.${ck}.weight`, v)}
                      ariaLabel={`${ck} weight`}
                    />
                  </td>
                  <td className="px-3 py-2 text-right">
                    <NumInput
                      value={c.cpa}
                      step={1}
                      onChange={(v) => set(`channelMix.${ck}.cpa`, v)}
                      ariaLabel={`${ck} CPA`}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
